import { action, makeAutoObservable } from "mobx"
import MicRecorder from 'mic-recorder-to-mp3'
import ApiService from "../services/ApiService";
import * as Base64_Blob from 'base64-blob'
import { User } from "../models/Users";
import Cookies from "js-cookie";
import { ProgStatus } from "../models/utilTypes";
import { MAX_VNOTE_TIME } from "../models/constants";
import { RecorderType } from "../models/app/RecorderType";
import { rootStore } from "../StApp";

type RecordStatus = 'init' | 'stop' | 'recording'
const mp3Recorder = new MicRecorder({ bitRate: 128 });

export class RecorderStore {

    recordState: RecordStatus = 'init'
    srcUrl: string = ''
    recordTimer: number = 0.0

    audioInterval: any = null
    audioTimeout: any = null

    mediaRecorder!: MediaRecorder
    blob: Blob | null = null
    api = ApiService
    msg!: string
    recepUser: User|null|undefined = null

    vNoteProgState: ProgStatus = 'INIT'
    recorderType: RecorderType



    constructor(recorderType: RecorderType, recepUser?: User| null| undefined) {

        this.recepUser = recepUser
        this.recorderType = recorderType
        makeAutoObservable(this, {
            audioInterval: false,
            audioTimeout: false,
            blob: false,
            msg: false,
            api: false,
            recepUser: false,
            recorderType: false
        })
    }

    recordSound() {
        this.recordTimer = 0.0

        navigator.mediaDevices.getUserMedia({ audio: true, video: false })
            .then((stream) => {
                this.handleSuccess(stream)
            });
    }

    stopRecording() {
        //this.mediaRecorder.stop()

        mp3Recorder
            .stop()
            .getMp3()
            .then(([buffer, blob]: any) => {

                this.blob = blob
                const blobURL = URL.createObjectURL(blob)
                this.srcUrl = blobURL
                this.recordState = 'stop'
                clearTimeout(this.audioTimeout)
                clearInterval(this.audioInterval)
            }).catch((e: any) => console.error(e));
    }

    @action
    private handleSuccess(stream: MediaStream) {

        mp3Recorder
            .start()
            .catch((e: any) => console.error(e));



        // const options = { mimeType: 'audio/webm' };
        // const recordedChunks: BlobPart[] | undefined = [];
        // this.mediaRecorder = new MediaRecorder(stream, options);

        // this.mediaRecorder.addEventListener('dataavailable', function (e) {
        //     if (e.data.size > 0) recordedChunks.push(e.data);
        // });



        // this.mediaRecorder.addEventListener('stop', async () => {
        //     const blob = new Blob(recordedChunks, { 'type': 'audio/ogg; codecs=opus' });
        //     //recordedChunks = [];
        //     const audioURL = window.URL.createObjectURL(blob);
        //     this.srcUrl = audioURL
        //     this.recordState = 'stop'
        //     clearTimeout(this.audioTimeout)
        //     clearInterval(this.audioInterval)
        // });


        this.audioTimeout = setTimeout(() => {
            this.stopRecording()
        }, this.recorderType*1000)



        this.audioInterval = setInterval(() => {
            console.log(this.recordTimer)
            this.recordTimer += 0.1
        }, 100)

        // this.mediaRecorder.start();
        this.recordState = 'recording'
    };

    setMsg(text: string) {

        this.msg = text

    }


    async sendVNote() {

        this.vNoteProgState = 'LOADING'
        const blobData = await Base64_Blob.blobToBase64(this.blob!)
        this.api.sendVNoteToUser({
            auth: rootStore.mainStore.token,
            data: {
                recep: this.recepUser!.userName,
                recepUid: this.recepUser!.uid,
                msg: this.msg,
                sender: rootStore.mainStore.userName,
                senderUid: rootStore.mainStore.uid?? undefined,
                time: new Date().toISOString(),
                vNote: blobData.split(',')[1]
            }
        }).then(resp => {

            this.vNoteProgState = 'SUCCESS'

            if (rootStore.mainStore.token == null) {
                rootStore.mainStore.setToken(resp.data.token)
                rootStore.mainStore.setUid(resp.data.uid)
                Cookies.set('uid', resp.data.uid)
                Cookies.set('token', resp.data.token)
            }



        })
        .catch(err=>{
            this.vNoteProgState = 'FAILED'
            console.log(err)
        })

    }


}